/*
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-11-03 11:42:01
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-26 17:35:50
 * @FilePath: /manage_property/src/config/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import storeAccount from './storeAccount';
import { ElMessage } from 'element-plus';

export { baseUrl, uploadUrl, isFake, request, responseError } from 'ai-assistant-lib/src/config/request';

//成功返回拦截
export const responseSuccess = (res) => {
  if (res.status == 200) {
    if (res.config.origin || Object.prototype.toString.call(res.data) === '[object Blob]') {
      //是否返回原本的数据，如下载文件
      return Promise.resolve(res.data);
    } else if (res.data.code == 200) {
      return Promise.resolve(res.data.data || res.data.results);
    } else if (res.data.code == 400) {
      ElMessage.error(res.data.message);
      if (res.data.message == '用户未登录') {
        const store = storeAccount();
        store.reset().then(() => {
          // window.location.reload();
          window.location.href = '/';
        });
      }
      return Promise.reject(res.data);
    } else {
      ElMessage.error(res.data.message || res.data.results[0]);
      return Promise.reject(res.data);
    }
  } else {
    return Promise.reject(res);
  }
};

export const handleStreamTxt = (res, type = 'json') => {
  // 按行分割数据，和算法人员确定了：一行一条记录，存在空行
  const result = res?.split(/\r?\n/);
  let list = [];
  result.forEach((item) => {
    // 去掉空行和非法数据行
    if (!item || item.indexOf('data:') === -1) {
      return;
    }
    // 有数据
    const data = item?.replace(/[\s]/g, '').split('data:')[1];
    switch (type) {
      case 'json':
        try {
          const d = JSON.parse(data);
          list.push(d);
        } catch (error) {
          console.error('error', item);
        }
        break;

      default:
        list.push(data);
        break;
    }
  });
  return list;
};
